import { setGameStatus } from '@/store/actions';
import { GameWindowResponse } from '../types';

export const dispatchRegionInfo = (
  regionInfo?: GameWindowResponse['data']['regionInfo'],
) => {
  if (!regionInfo) {
    return;
  }

  const { status: currentRegionStatus } = regionInfo?.currentRegion ?? {};

  if (currentRegionStatus !== 'active') {
    setGameStatus({ maintenanceMode: true });
  } else {
    setGameStatus({ maintenanceMode: false });
  }
};
